import { breadcrumbNodes } from '../../assets/routes/breadcrumbConfig';

/**
 * Matchea `pathname` contra `pattern` (soporta segmentos `:param`).
 * Retorna `{ params }` si matchea o `null`.
 */
export function matchPath(pattern, pathname) {
  const patternParts = pattern.split('/').filter(Boolean);
  const pathParts = pathname.split('/').filter(Boolean);
  // "/" (root) se normaliza a array vacío — matchea solo cuando ambas son vacías.
  if (pattern === '/' && pathname === '/') return { params: {} };
  if (pattern === '/' || pathname === '/') return null;
  if (patternParts.length !== pathParts.length) return null;

  const params = {};
  for (let i = 0; i < patternParts.length; i++) {
    if (patternParts[i].startsWith(':')) {
      params[patternParts[i].slice(1)] = pathParts[i];
    } else if (patternParts[i] !== pathParts[i]) {
      return null;
    }
  }
  return { params };
}

export function resolveHref(pattern, params) {
  if (pattern === '/') return '/';
  return pattern
    .split('/')
    .map((seg) => (seg.startsWith(':') ? params[seg.slice(1)] ?? seg : seg))
    .join('/');
}

export function findNode(pathname, nodes = breadcrumbNodes) {
  for (const node of nodes) {
    const matched = matchPath(node.match, pathname);
    if (matched) return { node, params: matched.params };
  }
  return null;
}

export function buildChain(pathname, nodes = breadcrumbNodes) {
  const found = findNode(pathname, nodes);
  if (!found) return [];

  const chain = [{ node: found.node, params: found.params }];
  let cursorParent = found.node.parent;
  let cursorParams = found.params;

  const maxDepth = 10;
  let depth = 0;

  while (cursorParent && depth < maxDepth) {
    const parentPath = resolveHref(cursorParent, cursorParams);
    const parentFound = findNode(parentPath, nodes);
    if (!parentFound) break;
    chain.unshift({ node: parentFound.node, params: parentFound.params });
    cursorParent = parentFound.node.parent;
    cursorParams = parentFound.params;
    depth += 1;
  }
  return chain;
}
